import { render, staticRenderFns } from "./Bare.vue?vue&type=template&id=b334c388&"
import script from "./Bare.vue?vue&type=script&lang=js&"
export * from "./Bare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports